import ShippingInfoResourceModel from '../../generated/types/model/resource/ShippingInfoResourceModel';

export default class ShippingInfoResourceViewModel extends ShippingInfoResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
